//on doom loaded
document.addEventListener('DOMContentLoaded', function () {
    // We need to set the close state as the full cart html rerenders on cart changes
    window.isFastItemsClose = false;

    function closeItemsSellingFast() {
        const container = document.querySelector('.js-fast-items_container')
        const cartHeader = document.querySelector('#shopify-section-ajax-cart .ajax-cart-yotpo-points-container')

        container.style.height = '0px';
        container.style.visibility = 'hidden';
        window.isFastItemsClose = true;
        cartHeader.style.marginBottom = '1em';
    }

    const closeIcon = document.querySelector('.js-close-fast-items')
    closeIcon?.addEventListener('click', closeItemsSellingFast);

    const observer = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
            // console.log("mutation")
            if (mutation.type === 'childList') {
                const closeIcon = document.querySelector('.js-close-fast-items')
                closeIcon?.addEventListener('click', closeItemsSellingFast);
                if (window.isFastItemsClose) {
                    closeItemsSellingFast();
                }
            }
        }
    });

    const cartContainer = document.getElementById('shopify-section-ajax-cart')
    observer.observe(cartContainer, { childList: true });
})